import React from 'react';
import styled, { keyframes } from 'styled-components';
import { translateMenuItemActions } from '../moreMenuActions';
import './More.css';

import {
  borderColor,
  imageBasePath,
} from '../../../library/constants';

const moreFunctions = ({
  nodeForFlipFocus,
  nodeObjs,
  flipData,
  translatedLabels,
  setShowFloaterPanel,
  addFloater,
  redraw,
  toggleFlipPanel,
  buildChoicesArray,
  decisionChoicesArray,
  fetchResolveAndPopModal,
  isPedigree,
  resizePhotoUploadModalForDesktopAndTablets,
  chartType,

}) => {


   if(typeof(flipData) === 'undefined' || flipData === null) return null;

   const menuItemActions = translateMenuItemActions( translatedLabels );

   if( chartType === 'fan' ) delete menuItemActions[9];

   const permissions = flipData.display;

   // console.log('permissions: ', JSON.stringify(permissions, null, 2));

    const fadeIn = keyframes`
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    `;

    let widestLength = 0;

    menuItemActions.forEach((menuItem, index) => {

      // console.log(`menuItem.label: `, menuItem.label);
      // console.log(`length: `, menuItem.label.length);

      if (menuItem.label.length > widestLength) widestLength = menuItem.label.length;
    })

    const widthOfMore = `${widestLength * 8}`;

    // console.log(`widthOfMore: `, widthOfMore);

    const Ul = styled.ul`
      list-style-type: none;
      webkit-animation-name:  ${fadeIn};
      -webkit-animation-duration: 0.4s;
      animation-name:  ${fadeIn};
      animation-duration: 0.4s;
      width: auto;
    `;

    const imgSize = 18;
/*
    const noImmediateFamily = () => {

      const nodeObj = nodeObjs[nodeForFlipFocus];

      return  typeof(nodeObj.immediateFam) !== 'undefined' &&
              typeof(nodeObj.immediateFam.parents) !== 'undefined' && nodeObj.immediateFam.parents.length <= 1 &&
              typeof(nodeObj.immediateFam.siblings) !== 'undefined' && nodeObj.immediateFam.siblings.length <= 1 &&
              typeof(nodeObj.immediateFam.children) !== 'undefined' && nodeObj.immediateFam.children.length <= 1 &&
              typeof(nodeObj.immediateFam.partners) !== 'undefined' && nodeObj.immediateFam.partners.length <= 1;
    }

    const removeResolveDuplicatesMenuItem = () => {

      if(noImmediateFamily()) return true;

    };
*/
    const listCompArray = menuItemActions.map((menuItem, index)=>{

      if(!permissions[menuItem.permission]) return null;

      // if(index === 13 && removeResolveDuplicatesMenuItem() ) return null;

      return (
        <li
          key={`idxLi-${index}`}
          style={{
            borderWidth: '1px',
            borderTop: `0px`,
            borderColor: borderColor,
            borderStyle: 'solid',
            boxSizing: 'border-box',
            padding: '6px',
            whiteSpace: 'nowrap',
            // width: `100%`,
            width: `${widthOfMore}px`,
            float: 'right',
            // right: `${(widestLength * 3) - 8 }px`,
            right: `2px`,
            position: 'relative',
            background: 'white',
            cursor: 'pointer',
          }}

          onTouchStart={()=>{

            const n = nodeForFlipFocus;

            let callback = null;
            if(index === 1){ // Add Photo
              callback = ()=>{
                resizePhotoUploadModalForDesktopAndTablets();
              }
            }
            if(index === 9){ // Move Profile
              callback = ()=>{
                if(decisionChoicesArray.length === 0 ) buildChoicesArray();
                setShowFloaterPanel(true);
                addFloater(nodeObjs[n].pr_id);
                toggleFlipPanel({close: true, from: 'more.js desktop'});
                setTimeout(() => {
                  redraw({});
                }, 1000);
              }
            }
            if(index === 13){ // Resolve
              callback = ()=>{
                fetchResolveAndPopModal({prId: nodeObjs[n].pr_id});
              }
            }

            menuItem.action(nodeObjs[n].pr_id, undefined, callback);

          }}

          onClick={()=>{

            const n = nodeForFlipFocus;

            let callback = null;

            if(index === 1){ // Add Photo
              callback = ()=>{
                resizePhotoUploadModalForDesktopAndTablets();
              }
            }
            if(index === 9){ // Move Profile
              callback = ()=>{
                if(decisionChoicesArray.length === 0 ) buildChoicesArray();
                setShowFloaterPanel(true);
                addFloater(nodeObjs[n].pr_id);
                toggleFlipPanel({close: true, from: 'more.js desktop'});
                setTimeout(() => {
                  redraw({});
                }, 1000);
              }
            }
            if(index === 13){ // Resolve
              callback = ()=>{
                fetchResolveAndPopModal({prId: nodeObjs[n].pr_id});
              }
            }

            menuItem.action(nodeObjs[n].pr_id, undefined, callback);
          }
      }>
          <img
              alt=""
              style={{
                width: `${imgSize}px`,
                height: `${imgSize}px`,
                boxSizing: `border-box`,
                float: `left`,
                marginRight: `6px`,
                opacity: .6,
              }}
               src={`${imageBasePath + `more_icons/` + menuItem.imgFile}` }
          />
          <div
          style={{
            fontSize: `13px`,
            float: `left`,
          }}>
            {menuItem.label}
          </div>
      </li>
      )
    })

  return (
    <Ul id="more-list">
      {listCompArray}
    </Ul>
  )
}

export default moreFunctions;

